import type { FC, ReactNode } from 'react'

import { Fragment } from 'react'

interface CopyLinesProps {
    lines: ReadonlyArray<string>
}

// One paragraph of site copy written as separate lines (a new line after a sentence or a phrase),
// so Japanese text never runs on after 「。」. Use it inside a <p>.
const CopyLines: FC<CopyLinesProps> = ({ lines }): ReactNode => (
    <>
        {lines.map((line, index) => (
            <Fragment key={`${index}-${line}`}>
                {index > 0 && <br />}
                {line}
            </Fragment>
        ))}
    </>
)

export default CopyLines
